import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BodyText, Div, Flex, Gutter, Title } from '@gaiads/telia-react-component-library';
import { TeliaTextInput } from '@teliads/components/react';

import { httpsUrlRegex } from '../utils';

import styles from './CompanyDevicePolicy.module.scss';

interface CompanyDevicePolicyProps {
  companyDevicePolicy?: string | null;
  setCompanyDevicePolicy: (policyUrl: string) => void;
  validationError?: string;
}

export default function CompanyDevicePolicy(props: CompanyDevicePolicyProps) {
  const { companyDevicePolicy, setCompanyDevicePolicy, validationError } = props;
  const [internalErrorMessage, setInternalErrorMessage] = useState<string | undefined>(validationError);
  const { t } = useTranslation('organizationForm');

  const handleInputChange = (value: string) => {
    setCompanyDevicePolicy(value);
    setInternalErrorMessage(undefined);
  };

  return (
    <Div padding={{ size: 'lg' }} boxShadow="md">
      <Title size={'sm'}>{t('company_device_policy.company_device_policy')}</Title>
      <Gutter size="layout-5" />
      <Flex directionColumn className={styles['']}>
        <BodyText size="md">{t('company_device_policy.paragraph1')}</BodyText>
        <Gutter size="layout-2" />
        <BodyText size="md">{t('company_device_policy.paragraph2')}</BodyText>

        <Gutter size="layout-5" />
        <TeliaTextInput
          className={styles['customer-organization-form__company-device-policy-inputs-container']}
          label={t('company_device_policy.company_device_policy_input_label')}
          onValueChange={(e: CustomEvent) => handleInputChange(e.detail.target.value)}
          value={companyDevicePolicy ?? ''}
          errorMessage={internalErrorMessage}
          patternErrorMessage={t('company_device_policy.company_device_policy_input_error')}
          pattern={httpsUrlRegex.source}
          dataTestid="company-device-policy"
        />
      </Flex>
    </Div>
  );
}
